import westAmc from "apis/westAmc";
import { WebApiRequest, HTTP_GET, HTTP_POST } from "../../tools/webservice";

export const getIsIntegrated = (controlIdNumber, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_GET,
  endpoint: westAmc.isIntegrated(controlIdNumber),
  successCallback,
  mountedRef
});

export const putWestAmcOnHold = (controlIdNumber, successCallback, errorCallback, mountedRef) => WebApiRequest({
  method: HTTP_POST,
  payload: {},
  endpoint: westAmc.OnHold(controlIdNumber),
  successCallback,
  errorCallback,
  mountedRef
});

export const putWestAmcOffHold = (controlIdNumber, successCallback, errorCallback, mountedRef) => WebApiRequest({
  method: HTTP_POST,
  payload: {},
  endpoint: westAmc.OffHold(controlIdNumber),
  successCallback,
  errorCallback,
  mountedRef
});